type FrontendExpectedErrorRule = {
  code: string
  operationPattern?: RegExp
}

type FrontendExpectedErrorsConfig = {
  common: FrontendExpectedErrorRule[]
  // The key should be the folder name of the domain.
  // Example: 'products' for domains/products
  // Example: 'insights-portal' for domains/insights-portal
  byDomain: Record<string, FrontendExpectedErrorRule[]>
}

export const expectedErrorsConfig: FrontendExpectedErrorsConfig = {
  common: [{ code: 'UNDETERMINED_ACCOUNT' }],
  byDomain: {},
}
